import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEllipsisVertical,
  faExchangeAlt,
  faSignOutAlt,
  faEdit,
  faRemove,
  faUserPlus
} from '@fortawesome/free-solid-svg-icons';

const ActionsMenu = ({ onActionSelect, onClose, mode, isLeft, isDuplicate, isReserv, currentStatus }) => {

  const menuRef = useRef(null);

  let actions = [];
  
  const canAcceptToGroup = !isLeft && mode === "edit" && isReserv && currentStatus === 'invite-accepted';
  
  if (isLeft) {
      actions = [
          {
              id: 'restore',
              label: 'Відновити дитину в групі',
              icon: faEdit
          },
          {
              id: 'view',
              label: 'Картка дитини',
              icon: faEdit
          }
      ];
  } else if (mode === "edit" && !isLeft && !isDuplicate && !isReserv) {
      actions = [
          {
              id: 'transfer',
              label: 'Перевести до групи поточного навчального року',
              icon: faExchangeAlt
          },
          {
              id: 'withdraw',
              label: 'Оформити вибуття зі садочку',
              icon: faSignOutAlt
          },
          {
              id: 'edit',
              label: 'Редагувати дані дитини',
              icon: faEdit
          },
          {
              id: 'transfer_external',
              label: 'Тимчасово перевести до групи в іншому садочку',
              icon: faExchangeAlt
          }
      ];
  } else if (mode === "edit" && !isLeft && !isDuplicate && isReserv) {
      actions = [
          {
              id: 'view',
              label: 'Картка дитини',
              icon: faEdit
          }
      ];
      
      if (canAcceptToGroup) {
          actions.unshift({
              id: 'accept_to_group',
              label: 'Оформити до групи',
              icon: faUserPlus
          });
      }
  } else if (mode === "edit" && !isLeft && isDuplicate) {
      actions = [
          {
              id: 'rem_dup',
              label: 'Видалити дублікат',
              icon: faRemove
          }
      ];
  } else {
      actions = [
          {
              id: 'view',
              label: 'Картка дитини',
              icon: faEdit
          }
      ];
  }

  const handleActionClick = (actionId) => {
    onActionSelect(actionId);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div 
      ref={menuRef}
      className="actions-dropdown"
      style={{
        position: 'absolute',
        right: 0,
        top: '100%',
        backgroundColor: 'white',
        border: '1px solid #dee2e6',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        zIndex: 1000,
        minWidth: '250px'
      }}
    >
      {actions.map((action) => (
        <button
          key={action.id}
          className="dropdown-item d-flex align-items-center gap-2 p-2"
          onClick={() => handleActionClick(action.id)}
          style={{
            border: 'none',
            backgroundColor: 'transparent',
            width: '100%',
            textAlign: 'left',
            fontSize: '14px',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
        >
          <FontAwesomeIcon icon={action.icon} style={{ width: '16px', color: '#6c757d' }} />
          <span style={{ color: '#212529' }}>{action.label}</span>
        </button>
      ))}
      
      <div style={{ borderTop: '1px solid #dee2e6', padding: '8px' }}>
        <button
          className="btn btn-sm btn-outline-secondary w-100"
          onClick={onClose}
          style={{ fontSize: '12px' }}
        >
          Скасувати
        </button>
      </div>
    </div>
  );
};

export default ActionsMenu;